export enum ArquivedEnum {
    Arquived = '1',
    NotArquived = '0',
}
